<template>
    <users-profile-venue-component v-if="isVenueProfile" @user-initialised="userInitialized"
                                   :user="user" @fetchUser="fetchUser">
    </users-profile-venue-component>

    <users-profile-escort-component v-else
                                    @user-initialised="userInitialized"
                                    :user="user"
                                    :isLoadingPrivateGalleries="isLoadingPrivateGalleries"
                                    @fetchUser="fetchUser"
                                    @galleryPurchased="fetchUserPrivateGalleriesPhotos"
    ></users-profile-escort-component>
</template>

<script>
import UsersProfileEscortComponent from "@/components/users/profile/UsersProfileEscortComponent";
import UsersProfileVenueComponent from "@/components/users/profile/UsersProfileVenueComponent";
import userMixin from "@/components/mixins/userMixin";
import profileGalleriesMixin from "@/components/mixins/profile/profileGalleriesMixin";
import userProfileMixin from "@/components/mixins/profile/userProfileMixin";

const data = () => {
    return {
        store: $store,
        user: null,
        fancyboxIndex: null,
        unSubscribe: null,
        isLoadingPrivateGalleries: false,
    }
}

function created() {
    this.user = this.store.getters.getPreFetchedUser || null;
    this.store.commit('setPreFetchedUser', null);
}

function mounted() {
    utils.injectCSS('/css/leaflet.css');

    this.unSubscribe = this.store.subscribe((mutation) => {
        if (mutation.type === 'setLoading') {
            this.user = null;
        }
    });

    /** Handle bfcache restoration - when user navigates back, mounted() doesn't re-run */
    window.addEventListener('pageshow', this.handlePageShow);

    if (!this.user) {
        this.fetchUser();
    } else {
        this.fetchUserPrivateGalleriesPhotos(true);
    }
}

function handlePageShow(event) {
    if (event.persisted && !this.user) {
        this.fetchUser();
    }
}

async function fetchUser() {
    const [err, response] = await to(
        api.seo.checkProfile(window.location.pathname),
    );

    if (err || !_.get(response, 'data.user', false)) {
        return this.store.commit('setIs404View', true);
    }

    this.user = _.get(response, 'data.user');
    await this.fetchUserPrivateGalleriesPhotos();
}

function userInitialized(user) {
    this.$emit('user-initialised', user);
}

export default {
    data,
    created,
    mounted,
    computed: {
        ...mapState([
            'translate', 'currentUser', 'isSeekingServicesProfile',
        ]),
    },
    components: {
        UsersProfileEscortComponent,
        UsersProfileVenueComponent,
    },
    mixins: [userMixin, profileGalleriesMixin, userProfileMixin],
    methods: {
        fetchUser,
        userInitialized,
        handlePageShow,
    },
    beforeDestroy() {
        if (this.unSubscribe) {
            this.unSubscribe();
        }
        window.removeEventListener('pageshow', this.handlePageShow);
    },
};
</script>
